import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

// CONSTANTS
import { cloudfront } from '@/constants/common';

// COMPONENTS
import Loader from '@/components/Loader/Loader';

// HELP
import ReasonItem from './help/ReasonItem/ReasonItem';

// STYLES
import { ReasonContainer } from './styles';

const Reasons = ({ t, content, loading }) => {
  const getReasons = () => {
    const reasons = [];
    for (let i = 1; i <= 6; i++) {
      const src = cloudfront + content[`icon-asset-${i}`];
      const title = content[`icon-title-${i}`];
      const text = content[`icon-text-${i}`];

      if (title) {
        reasons.push(
          <Grid item xs={12} sm={6} key={i}>
            <ReasonItem src={src} title={title} text={text} />
          </Grid>,
        );
      }
    }

    return reasons;
  };

  return (
    <ReasonContainer className="section reason content-visibility--auto">
      <div className="page-content">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography className="reason__title" variant="h1">
              {t('home.reason.title1')}{' '}
              <b className="text-color text-color--purple cut-line">{t('home.reason.title2')}</b>{' '}
              <b>{t('home.reason.title3')}</b>
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={4}>
              {getReasons()}
            </Grid>
          </Grid>
        </Grid>
        <Loader active={loading} />
      </div>
    </ReasonContainer>
  );
};

Reasons.propTypes = {
  t: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

export default withTranslation()(React.memo(Reasons));
